// 获取个人信息
import allUrl from "../api/allUrl";
import { post, get, postRaw } from "../api/service/services";
import { Toast } from "antd-mobile-v2";
import tool from "../api/tool";
import sectioValue from "../api/service/secsstion";
export const userInfoData = () => {
  return new Promise((resolve, reject) => {
    get(allUrl.register.getUserInfo, {
      userCode: sectioValue.get("acount") || "",
    })
      .then((res) => {
        if (res.code == 200) {
          tool.set("userInfoData", res.data);
          resolve(res.data);
        } else {
          Toast.fail(res.msg, 1);
        }
      })
      .catch((err) => {
        Toast.fail("个人信息获取失败", 1);
      });
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      Toast.fail("密保问题数据获取失败", 1);
    });
};
